import ResourceLink from 'components/common/digitalResourcesMaps/resourceLink';
import React, { useCallback } from 'react';
import { IDResource, MapGroupProps } from 'types';
import { getPictureByUrl, onFaviconError } from 'utils/helpers/resourcesMap';

const ScienceLink: React.FC<MapGroupProps> = ({
  resources,
  onHoveredElementChanged,
  onClick,
}) => {
  const onElementHover = useCallback(
    (resource?: IDResource, target?: SVGElement) => {
      if (onHoveredElementChanged) {
        onHoveredElementChanged(resource, target);
      }
    },
    [onHoveredElementChanged]
  );

  const resource1SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <linearGradient
        id="SVGID_13_"
        x1="776.171"
        x2="843.975"
        y1="182.388"
        y2="182.388"
        gradientTransform="rotate(-25.604 810.161 185.217)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#FFA511" />
        <stop offset="0.984" stopColor="#FFA511" />
      </linearGradient>
      <rect
        x="15.41"
        y="20.66"
        width="66.18"
        height="65.83"
        rx="14.07"
        transform="translate(-19.82 30.02) rotate(-28.82)"
        fill="#fff"
        strokeMiterlimit="10"
        strokeWidth="4"
        stroke="url(#SVGID_13_)"
      />
      <image
        width="52"
        height="52"
        transform="translate(13 43) rotate(-28.82)"
        href={getPictureByUrl(resources[0]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource2SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <linearGradient
        id="SVGID_12_"
        x1="841.806"
        x2="913.779"
        y1="143.369"
        y2="143.369"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#FFA511" />
        <stop offset="0.984" stopColor="#FFA511" />
      </linearGradient>
      <rect
        x="109.41"
        y="10.45"
        width="66.18"
        height="65.83"
        rx="14.07"
        transform="translate(-1.22 4.23) rotate(-1.69)"
        fill="#fff"
        strokeMiterlimit="10"
        strokeWidth="4"
        stroke="url(#SVGID_12_)"
      />
      <image
        width="52"
        height="52"
        transform="translate(116 18) rotate(-1.69)"
        href={getPictureByUrl(resources[1]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource3SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <linearGradient
        id="SVGID_11_"
        x1="915.016"
        x2="976.62"
        y1="122.606"
        y2="122.606"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#FFA511" />
        <stop offset="0.984" stopColor="#FFA511" />
      </linearGradient>
      <rect
        x="204.64"
        y="18.83"
        width="66.18"
        height="65.83"
        rx="14.07"
        transform="matrix(1, 0.08, -0.08, 1, 4.65, -18.01)"
        fill="#fff"
        strokeMiterlimit="10"
        strokeWidth="4"
        stroke="url(#SVGID_11_)"
      />
      <image
        width="52"
        height="52"
        transform="matrix(1, 0.08, -0.08, 1, 214, 24)"
        href={getPictureByUrl(resources[2]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource4SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <linearGradient
        id="SVGID_9_"
        x1="831.729"
        x2="903.724"
        y1="236.319"
        y2="236.319"
        gradientTransform="rotate(-4.156 865.785 230.012) scale(1.00003)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#FFA511" />
        <stop offset="0.984" stopColor="#FFA511" />
      </linearGradient>
      <rect
        x="23.89"
        y="105.98"
        width="66.18"
        height="65.83"
        rx="14.07"
        transform="translate(-28.84 15.71) rotate(-12.56)"
        fill="#fff"
        strokeMiterlimit="10"
        strokeWidth="4"
        stroke="url(#SVGID_9_)"
      />
      <image
        width="52"
        height="52"
        transform="translate(26 120) rotate(-12.56)"
        href={getPictureByUrl(resources[3]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );
  const resource5SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <linearGradient
        id="SVGID_10_"
        x1="902.864"
        x2="975.387"
        y1="198.965"
        y2="198.965"
        gradientTransform="rotate(-24.03 941.464 202.186)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#FFA511" />
        <stop offset="0.984" stopColor="#FFA511" />
      </linearGradient>
      <rect
        x="101.87"
        y="91.08"
        width="66.18"
        height="65.83"
        rx="14.07"
        transform="translate(9.87 -9.95) rotate(4.38)"
        fill="#fff"
        strokeMiterlimit="10"
        strokeWidth="4"
        stroke="url(#SVGID_10_)"
      />
      <image
        width="52"
        height="52"
        transform="translate(111 96) rotate(4.38)"
        href={getPictureByUrl(resources[4]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource6SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <linearGradient
        id="SVGID_14_"
        x1="972.811"
        x2="1035.764"
        y1="161.261"
        y2="161.261"
        gradientTransform="rotate(17.855 1006.45 166.997)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#FFA511" />
        <stop offset="0.984" stopColor="#FFA511" />
      </linearGradient>
      <rect
        x="178.21"
        y="94.77"
        width="66.18"
        height="65.83"
        rx="14.07"
        transform="translate(10.37 -15.77) rotate(4.38)"
        fill="#fff"
        strokeMiterlimit="10"
        strokeWidth="4"
        stroke="url(#SVGID_14_)"
      />
      <image
        width="52"
        height="52"
        transform="translate(188 99) rotate(4.38)"
        href={getPictureByUrl(resources[5]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  return (
    <g className="digital-resources-science" transform="translate(503, 404)">
      <defs>
        <linearGradient
          id="bbef953a-b497-4034-beba-74bae413a68a"
          data-name="grad-28"
          x1="221.08"
          y1="172.69"
          x2="221.47"
          y2="221.05"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.08" stopColor="#f4cb76" />
          <stop offset="1" stopColor="#bf534f" />
        </linearGradient>
        <linearGradient
          id="bcd687ac-cbad-488a-b2d8-c00a9939dfb4"
          x1="217.98"
          y1="188.46"
          x2="218.19"
          y2="215.18"
          xlinkHref="#bbef953a-b497-4034-beba-74bae413a68a"
        />
        <linearGradient
          id="b239a442-2153-46fe-a8dc-2786a0a62fdb"
          x1="221.21"
          y1="194.93"
          x2="220.27"
          y2="230.03"
          xlinkHref="#bbef953a-b497-4034-beba-74bae413a68a"
        />
      </defs>
      <g id="a0e4f1eb-6749-4669-8dce-a6138c461258" data-name="science">
        <g>
          <path
            d="M530.17,240.44a59.3,59.3,0,0,0-14,6.14c-8,4.72-15.47,11.27-22.6,19l-.28.3-.26.29-1.71,1.91A226.39,226.39,0,0,0,477.19,286c-.57.79-1.13,1.58-1.69,2.39-.35.5-.71,1-1.06,1.51-.77,1.1-1.54,2.22-2.3,3.34-3.34,4.91-6.61,10-9.84,15.06-2.93,4.64-5.83,9.33-8.7,14-4.75,7.74-9.43,15.43-14.09,22.78L438,347.53q-1.92,3-3.85,5.94c-.48.73-1,1.46-1.45,2.18l-.09.14q-2.31,3.46-4.63,6.74c-.3.44-.61.87-.92,1.3-.46.65-.93,1.29-1.39,1.93-.85,1.16-1.69,2.3-2.54,3.41-.4.53-.8,1.06-1.22,1.58-.58.76-1.17,1.51-1.76,2.25H257c-5-2.08-9.83-4.16-14.59-6.2l-6.89-3-.33-.15-.06,0c-25.91-11.22-75.68-46.39-115.34-79.15l0,0c-12.17-10.05-23.39-19.87-32.66-28.72,0,0,0,0,0,0q-3.63-3.45-6.84-6.69A138.65,138.65,0,0,1,65.56,232.3l-.25-.35c-.53-.77-1-1.5-1.44-2.21-1.62-2.66-2.49-4.86-2.49-6.52,0,0,30.17-1,76.4-1.57h0c21.76-.27,47.07-.44,74.47-.36h0l13.34.06h0c22.4.13,46,.43,70,1l3.66.08,3.15.08h0q10.46.25,21,.59c11.74.36,23.51.8,35.23,1.31,45.19,1.95,89.61,5,128.38,9.69q11,1.32,21.3,2.82h0l1.86.28q7.16,1,13.94,2.2l.28.05C526.35,239.76,528.27,240.1,530.17,240.44Z"
            fill="#5761ec"
          />
          <path
            d="M265.77,373h-2.64c-22.29-14.77-54.74-43.5-64.92-74-9.64-28.94-21.69-48.49-27.68-57.17-.79-1.15-1.48-2.11-2-2.87-1.09-1.48-1.7-2.23-1.7-2.23,24.73,2,37.52,3.81,37.52,3.81-.12,1.12-.32,3.21-.46,6.1,0,.78-.07,1.61-.09,2.5C203.11,271.87,207.44,330.65,265.77,373Z"
            fill="#003a46"
            opacity="0.51"
          />
          <path
            d="M334.28,271.61a4.85,4.85,0,0,1,2.5.76C331.36,271.76,329.43,271.41,334.28,271.61Z"
            fill="#003a46"
            opacity="0.61"
          />
          <path
            d="M362.71,318c-3.34,13.36-1,35.84,2.28,55h-2c-7.17-26.11-16.49-57.84-20.35-61.71a6.34,6.34,0,0,1-1.39-2.3s0,0,0,0a12.85,12.85,0,0,1-.68-2.59s0,0,0,0c-1.6-9.34,1.9-26.63-2.38-32.61l-.17-.24a5,5,0,0,0-1.2-1.1l1.86.2c11.64,1.24,34.55,3.29,46,4.06h.1l1.44.1C402.88,277.81,369.4,291.21,362.71,318Z"
            fill="#003a46"
            opacity="0.61"
          />
          <path
            d="M493,266.2l-1.71,1.91A226.39,226.39,0,0,0,477.19,286l-1.69,2.39c-.35.5-.71,1-1.06,1.51-.77,1.1-1.54,2.22-2.3,3.34-3.34,4.91-6.61,10-9.84,15.06-2.94,4.64-5.83,9.33-8.7,14-4.75,7.74-9.43,15.43-14.09,22.78L438,347.53q-1.92,3-3.85,5.94c-.48.73-1,1.46-1.45,2.18l-.09.14q-2.31,3.46-4.63,6.74c-.3.44-.61.87-.92,1.3-.46.65-.93,1.29-1.39,1.93-.85,1.16-1.69,2.3-2.54,3.41-.4.53-.8,1.06-1.22,1.58-.58.76-1.17,1.51-1.76,2.25l-.69.85c.23-.28.46-.56.68-.85h-19c22.16-43.56,34.14-96.26,38.48-96.26C447,276.74,493,266.2,493,266.2Z"
            fill="#003a46"
            opacity="0.51"
          />
          <path
            d="M68.75,224.2l35,2.47a1.83,1.83,0,0,1,1.37.76C112,237,187.47,340.59,240.85,366.73a1.86,1.86,0,0,0,1.71-3.31c-44-24.53-160.85-93.08-175.72-136.78A1.87,1.87,0,0,1,68.75,224.2Z"
            fill="#003a46"
            opacity="0.51"
          />
          <path
            d="M563.14,186.82c-4.81,28.42-35.3,53.84-66.68,69.88a150,150,0,0,1-22.5,9.21c-111.45,36-295.71-29.3-337.75-29.3A595.78,595.78,0,0,1,62.77,232c-27.25-3.61-51.67-9.72-59.42-19.51a10.47,10.47,0,0,1-2.25-9.3C7.54,176.34,52.56,163,91.17,163s173.7-40.17,250.89-53.56S493.82,92.74,541.5,136.17C560.24,153.24,565.9,170.53,563.14,186.82Z"
            fill="#5784ec"
          />
          <path
            d="M315.13,373h-4.72l-6.12-7.14-4.88-5.69c-22.24-25.9-49.1-56.93-56.31-64.13-11-11-14.85-34.74-22.77-43.24a9.16,9.16,0,0,0-4.52-2.89c17.29,3.5,17.36,3.7,17.36,3.7l49.59,10.74a8.28,8.28,0,0,0-2.07.71c-3.73,1.77-10.91,7.75-8,27.12,1.78,11.87,14.45,35.27,27.57,57,1.8,3,3.62,5.95,5.41,8.84h0C308.94,363.32,312.15,368.37,315.13,373Z"
            fill="#003a46"
            opacity="0.51"
          />
          <path
            d="M566.8,184.24a57.07,57.07,0,0,1-5.66,18.51,89,89,0,0,1-10.75,16.32,123.17,123.17,0,0,1-13.62,14.07,176.88,176.88,0,0,1-15.35,12.19c-5.33,3.76-10.89,7.22-16.57,10.45a155.07,155.07,0,0,1-17.74,8.71,168.93,168.93,0,0,1-18.68,6.45c-6.34,1.79-12.73,3.32-19.18,4.54a289.64,289.64,0,0,1-39,4.51c-13,.72-26.07.63-39,.1A657.81,657.81,0,0,1,294,271.71c-12.75-2.08-25.44-4.47-38.09-7s-25.22-5.32-37.76-8.17l-37.49-8.73c-6.23-1.45-12.45-2.87-18.66-4.18s-12.42-2.59-18.51-3.46c-1.53-.22-3-.39-4.52-.54-.73,0-1.49-.13-2.2-.17s-1.37-.07-2.23-.08q-4.86-.12-9.71-.33c-6.47-.29-12.93-.63-19.37-1.14-12.89-1-25.75-2.38-38.55-4.25-6.39-1-12.78-2.1-19.13-3.48a167.25,167.25,0,0,1-18.83-5.08,75.07,75.07,0,0,1-17.74-8.35,28.15,28.15,0,0,1-7.13-6.81,12,12,0,0,1-2-4.54,10.22,10.22,0,0,1,.31-4.83,10.07,10.07,0,0,0,.24,4.7,11,11,0,0,0,2.26,4,26.61,26.61,0,0,0,7.41,5.65A72.78,72.78,0,0,0,30,221.28c12.31,2.94,25,4.37,37.67,5.38s25.44,1.71,38.19,2c6.37.12,12.74.23,19.1.19,3.19,0,6.36-.05,9.54-.12.74,0,1.71,0,2.58,0s1.74.06,2.61.09c1.71.1,3.39.24,5.06.41,13.23,1.44,25.82,4,38.48,6.54s25.15,5.27,37.7,7.85,25,5.21,37.6,7.61,25.09,4.72,37.66,6.77,25.17,3.91,37.79,5.44,25.25,2.73,37.9,3.54c25.27,1.53,50.66,1.43,75.51-2.2,6.2-1,12.37-2.08,18.46-3.52s12.11-3.17,18-5.2a146.56,146.56,0,0,0,17.25-7.26c5.66-2.78,11.18-5.84,16.57-9.1a150.81,150.81,0,0,0,29.83-23.14,86.73,86.73,0,0,0,11.79-14.79A58.46,58.46,0,0,0,566.8,184.24Z"
            fill="#dcf9f7"
          />
          <path
            d="M529.58,150.56c-36-33.83-92.22-31.3-150.45-20.87S219,171.42,189.85,171.42s-109.12,6.11-114,27,114.8,27.26,147.93,38.72c32.1,11.1,233,23,271.79,7.34S568.4,187.07,529.58,150.56Z"
            fill="#fff"
            opacity="0.13"
          />
          <g>
            <g opacity="0.25">
              <path
                d="M23.3,193.12s10.64-8.45,11.86-12.35,2.9-4,1.36-4.59c-4.58-1.83-3.42-7.45,6.87-4,12.84,4.32,11.74,9.58,2.12,8.12-2.35,1.6-3.15,2.67-4.36,3.54-1,.69,1.5,6-15.64,11.51Z"
                fill="#531063"
              />
              <ellipse
                cx="43.66"
                cy="175.86"
                rx="2.17"
                ry="7.56"
                transform="translate(-136.97 161.41) rotate(-71.48)"
                fill="#531063"
              />
              <path
                d="M36.26,188.18c3.19-.41,5.49-1.56,7.65-2s4.52-2.38,6.81-3.21,9.69-2.78,6.9-8.77c-3.45-2.66.65-5.81,10-2.64s11,5.8,8.85,7.18c-1.41.91-1.83,4.41-11,5.22s-13.87,2.69-14.48,3.4-2.61,4.48-9.78,5.84-17,2.53-17,2.53Z"
                fill="#531063"
              />
              <ellipse
                cx="67.23"
                cy="175.05"
                rx="2.17"
                ry="7.56"
                transform="translate(-120.1 183.21) rotate(-71.48)"
                fill="#531063"
              />
              <path
                d="M45.88,190c3.24-.53,8.48.47,12.26.66,1.71.09,4.09.49,6.56.74,3.87.39,7.18-.83,8-2.93,1-2.43,6.15-3.93,9.6-.31,3.24,3.41,5.35,7.59,2.09,9.75-1.74,1.15-4.77.42-6.73-.77a11.43,11.43,0,0,0-6.13-1.4,31.21,31.21,0,0,1-9.28-.87c-3.56-.79-14.24-1.33-24.23,1.64s-12.08,1.36-12.25.86a16,16,0,0,1-.31-2Z"
                fill="#531063"
              />
              <ellipse
                cx="80.02"
                cy="192.49"
                rx="3.09"
                ry="5.29"
                transform="matrix(0.78, -0.62, 0.62, 0.78, -102.16, 91.17)"
                fill="#531063"
              />
              <path
                d="M44.58,192.22A12.84,12.84,0,0,0,51,187.33c.61-.71,5.29-2.6,14.48-3.4,7.53-.66,9.24-3,10-4.46a20.11,20.11,0,0,1-9.15-.77c1.4,1.58,2,2.39-.66,3.32s-4-.45-11.41,3-6.69,6-11.56,6.53c-3.29.36-9.66,2.27-13.46,3.48,1.73-.24,3.75-.53,5.82-.85Z"
                fill="#531063"
                opacity="0.47"
              />
              <g>
                <path
                  d="M57.75,174.48a4.5,4.5,0,0,1-.41,4.79c2.43-1.59,6.17-1.45,6.17-1.45A21.63,21.63,0,0,1,57.75,174.48Z"
                  fill="#531063"
                  opacity="0.47"
                />
                <polygon
                  points="56.02 180.54 56.02 180.54 56.02 180.54 56.02 180.54"
                  fill="#531063"
                />
              </g>
              <path
                d="M38.07,196.48c10-3,20.67-2.43,24.23-1.64,5.19,1.45,12.31.47,15.09,1.75,0,0-3.06-2.65-3.46-4.39-.76,2.05-1.49,2.76-5.71,2.79s-5.52-.9-9.56-1.35a74.25,74.25,0,0,0-13.4.18c-2.94.35-12.5,3.42-14.74,3.47s-4.7.05-4.7.05l2.26.88C29.83,198.34,32.88,198,38.07,196.48Z"
                fill="#531063"
                opacity="0.47"
              />
              <path
                d="M27.51,190.93c2.34-.62,2-3.25,5.25-5s2.68-3.42,4.13-5.43,2.13-1.65,3.87-2.22a12.26,12.26,0,0,1-3.64-1.53h0a17.85,17.85,0,0,0-2,4c-1.22,3.9-11.86,12.35-11.86,12.35C24.42,192.94,25.18,191.54,27.51,190.93Z"
                fill="#531063"
                opacity="0.47"
              />
              <path
                d="M38.74,189a50.85,50.85,0,0,0,8.62-3c1.69-.77,9.54-3.93,9.12-4.69a6.51,6.51,0,0,0-.5-.75,15.36,15.36,0,0,1-3.91,1.92h0s-3.34,1.66-5.84,2.77a9.89,9.89,0,0,1-2.32.9l-.63.16c-2,.52-.86.79-3.75,1.16C38.31,188.23,36.62,189.38,38.74,189Z"
                fill="#531063"
              />
              <path
                d="M83.3,191.9c-1.23-2.31-3.55-4.07-5.37-4A2,2,0,0,0,76,189.68C78.41,188.26,81.7,190.56,83.3,191.9Z"
                fill="#531063"
                opacity="0.47"
              />
              <path
                d="M68.67,173.26c-3.9-1.44-7.7-1.8-8.49-.81-.28.35-.13.82.33,1.35,1.15-2.42,12.26,1.8,13,2.09A16.1,16.1,0,0,0,68.67,173.26Z"
                fill="#531063"
                opacity="0.47"
              />
              <path
                d="M44.53,174.06l-.69-.41c-3.43-1.07-6.53-1.27-7.24-.39-.33.42-.05,1,.64,1.65.21-.06.71.22,1.76,1.26l.21.11C36.82,172.21,44.53,174.06,44.53,174.06Z"
                fill="#531063"
                opacity="0.47"
              />
            </g>
            <g>
              <path
                d="M21.48,196.43s-6.56-14.62-10.72-18.53S7,172.64,5.85,173.36c-3.53,2.14-9.71-3-2.52-8.32,9-6.61,14.75-1.77,10.08,4.54,1.14,3,2.14,4.46,2.78,6,.5,1.26,7.43,3.4,8.57,20.8Z"
                fill="#64cc2b"
              />
              <ellipse
                cx="7.68"
                cy="167.62"
                rx="6.24"
                ry="2.96"
                transform="translate(-91.63 32.36) rotate(-33.66)"
                fill="#170"
              />
              <path
                d="M19.72,182.69c.5-2.77-.13-5.42,0-7.44s-1.39-5.29-1.64-7.69-.26-9.58-8.07-12c-4.16.63-6.56-4.92,0-9.71s10.12-4.06,11.06-1.36c.63,1.78,4.57,4.77,2.68,12.46s-1.13,12.73-.5,13.74,4.41,5.42,3.78,12-2.27,15-2.27,15Z"
                fill="#64cc2b"
              />
              <ellipse
                cx="13.98"
                cy="148.84"
                rx="6.24"
                ry="2.96"
                transform="translate(-80.16 32.71) rotate(-33.66)"
                fill="#170"
              />
              <path
                d="M24.76,176.64c.38-2.9,3.15-6.18,4.54-8.95.62-1.25,1.83-2.78,2.88-4.49a7,7,0,0,0-.94-8.43c-2.51-2.61-2.68-7.73,2.6-7.64,4.95.1,10.46,1.64,12,5.8.8,2.22-1,4-3,4.61a5.45,5.45,0,0,0-3.51,3.66,15,15,0,0,1-3.86,6.49c-2,2.14-5.93,10-5.55,19.92S27.79,198,27.15,197.69s-2.39-1.26-2.39-1.26Z"
                fill="#64cc2b"
              />
              <ellipse
                cx="38.19"
                cy="152.24"
                rx="2.96"
                ry="6.24"
                transform="translate(-118.52 143.3) rotate(-72.65)"
                fill="#170"
              />
              <path
                d="M27,179.35a18.89,18.89,0,0,0-3.73-8.64c-.63-1-1.39-6.05.5-13.74,1.55-6.31-.63-9.39-2.09-11.13A10,10,0,0,1,18,152.3c2.27.13,3.41.26,3.66,3s-1.77,2.77,0,11.1,4.91,9.7,4,13.86c-.59,2.81-.33,9.17-.09,13,.25-1.51.54-3.29.8-5.12Z"
                fill="#11366d"
                opacity="0.47"
              />
              <g>
                <path
                  d="M10.4,155.71a10.37,10.37,0,0,1,5.44,3.95,8.26,8.26,0,0,1,.22-5.84A14,14,0,0,1,10.4,155.71Z"
                  fill="#11366d"
                  opacity="0.47"
                />
                <polygon
                  points="16.91 161.66 16.91 161.66 16.91 161.66 16.91 161.66"
                  fill="#170"
                />
              </g>
              <path
                d="M29.93,187.61c-.38-10,3.53-17.78,5.55-19.92,3.27-2.9,4.33-9.13,6.67-10.31,0,0-4,.35-6.17-.66,2.14,2.14,2.74,3.24,1.48,6.52s-2.74,3.56-4.51,6.34A38.12,38.12,0,0,0,29.05,180c-.51,2.52.12,12.23-.51,14s-1.39,3.65-1.39,3.65l1.72-1.07C29.55,195.36,30.12,192.78,29.93,187.61Z"
                fill="#11366d"
                opacity="0.47"
              />
              <path
                d="M20.22,191.52c0-2.27-3.15-4-4.16-7.82s-3.15-4.67-5-7.31-1.26-2.9-1.39-4.67a6.64,6.64,0,0,1-2.9,1.63h0a40.08,40.08,0,0,0,4,4.55c4.16,3.91,10.72,18.53,10.72,18.53C21.61,195.42,20.22,193.79,20.22,191.52Z"
                fill="#11366d"
                opacity="0.47"
              />
              <path
                d="M21.48,181.43c.25-1.89-.5-7.06-.88-9S19,162.14,18,161.89a7.76,7.76,0,0,0-1-.19,15.91,15.91,0,0,1,1,4.47h0s.91,3.84,1.42,6.61a8.37,8.37,0,0,1,.35,2.47c0,.17,0,.38,0,.61,0,1.92.66,1.26.2,3.77C20.41,181.14,21.23,183.32,21.48,181.43Z"
                fill="#86e04b"
              />
              <path
                d="M38.52,149.27c-3.08-.82-5.83-.36-6.29,1.11-.27.87.33,1.89,1.46,2.82C32.78,150.27,36.46,149.48,38.52,149.27Z"
                fill="#11366d"
                opacity="0.47"
              />
              <path
                d="M12.34,146.37c-2.87,1.91-4.46,4.56-3.56,5.93a2.08,2.08,0,0,0,1.68.77C8,150.34,16.32,145,16.9,144.62A9.87,9.87,0,0,0,12.34,146.37Z"
                fill="#11366d"
                opacity="0.47"
              />
              <path
                d="M5.85,165.58l-.69.22c-2.3,1.83-3.49,4.07-2.68,5.28a2.31,2.31,0,0,0,2.12.77c0-.21.47-.38,2-.41l.19-.07C1.33,170.12,5.85,165.58,5.85,165.58Z"
                fill="#11366d"
                opacity="0.47"
              />
            </g>
            <path
              d="M32.57,156.74a4.64,4.64,0,0,1,.67,2.4,8.84,8.84,0,0,1-.28,2.51,16.08,16.08,0,0,1-2.06,4.56c-1.73,2.75-3.51,5.46-5.43,8.12a31.65,31.65,0,0,1,2-4.49c.75-1.45,1.58-2.86,2.44-4.25a22.34,22.34,0,0,0,2.18-4.2A8,8,0,0,0,32.57,156.74Z"
              fill="#86e04b"
            />
            <path
              d="M34.54,147.43c-.67.38-1.3.71-1.87,1.08a3.78,3.78,0,0,0-1.32,1.24,1.9,1.9,0,0,0,0,1.61c.09.3.26.61.39.94a9.13,9.13,0,0,1,.5,1,7.52,7.52,0,0,1-1-.64,5.15,5.15,0,0,1-.77-.9,2.53,2.53,0,0,1-.16-2.56,3.48,3.48,0,0,1,2-1.5A4.85,4.85,0,0,1,34.54,147.43Z"
              fill="#86e04b"
            />
            <path
              d="M9.53,148c-.41.64-.82,1.23-1.15,1.82a3.72,3.72,0,0,0-.59,1.72A1.92,1.92,0,0,0,8.5,153c.23.22.52.42.79.65a8.32,8.32,0,0,1,.9.64,7.48,7.48,0,0,1-1.14-.12A4.79,4.79,0,0,1,8,153.73a2.49,2.49,0,0,1-1.34-2.19,3.5,3.5,0,0,1,1-2.24A5,5,0,0,1,9.53,148Z"
              fill="#86e04b"
            />
            <path
              d="M2.93,166.17a19.76,19.76,0,0,0-.91,2,4.09,4.09,0,0,0-.3,1.89,2.51,2.51,0,0,0,.86,1.58c.23.24.54.43.82.68s.62.4.94.66a7.76,7.76,0,0,1-1.18-.14A5,5,0,0,1,2,172.4a2.92,2.92,0,0,1-1.47-2.15,3.7,3.7,0,0,1,.65-2.45A4.79,4.79,0,0,1,2.93,166.17Z"
              fill="#86e04b"
            />
          </g>
          <g>
            <path
              d="M254.31,216.6a4.47,4.47,0,0,0,1.38-8.41c-3.84-1.92-8.89-2.74-13.31-.84,13.11-5.62,19.82-12.49,11.23-18.73-6.86-5-17.47,13.11-20,13.11s1.25-7.49,6.87-14.36,5-12.48.62-14.35-11.86,1.25-13.73,20.6c0-3.12,1.25-22.47-3.74-20.6s-8.74,12.48-.63,23.72c-5,1.87-4.37-3.12-4.37-3.12s-2.49-18.73-11.23-15-6.24,13.73,0,20,6.24,10-1.87,6.24-11.86-12.48-19.35-3.75,13.11,19.35,25,20C219.77,221.53,242.47,218.37,254.31,216.6Z"
              fill="url(#bbef953a-b497-4034-beba-74bae413a68a)"
            />
            <path
              d="M246.76,214.92c.44-3.55-6.21-7.1-11.53-2.66,8-7.1,9.75-12.86,5.76-12.86s-12.85,7.54-14.63,7.54,3.92-3.45,7.91-8.33,1.85-8.66-1.25-10c-2.91-1.24-11.74,1.56-14,13.16a2,2,0,0,1-1.39,1.53c-.68.22-1.46-1.58-1.46-1.58s-4-15.19-10.2-12.53-4.43,9.76,0,14.19,4.43,7.09-1.33,4.43-8.42-8.86-13.74-2.66,6.2,9.31,14.63,9.76S246.76,214.92,246.76,214.92Z"
              fill="url(#bcd687ac-cbad-488a-b2d8-c00a9939dfb4)"
            />
            <path
              d="M231.27,219.89c-1.67-.6,4.85-1.92,10.26-5.16s4.67-7.52,2.2-9.82c-2.31-2.16-11.56-2.51-17.62,7.64a2,2,0,0,1-1.83,1c-.72,0-.84-2-.84-2s1.39-15.65-5.35-15.25-7.48,7.68-4.81,13.35,1.77,8.18-2.75,3.72-4.92-11.19-12-7.15,2.69,10.86,10.46,14.13S232.94,220.49,231.27,219.89Z"
              fill="url(#b239a442-2153-46fe-a8dc-2786a0a62fdb)"
            />
          </g>
        </g>
        <g>
          <ellipse
            cx="169.37"
            cy="191.96"
            rx="19.61"
            ry="11.3"
            fill="#3a3fa0"
          />
          <path
            d="M176.36,190.43c0,3.61-6.62,6.54-14.78,6.54S146.8,194,146.8,190.43c0-.75.06-2.94.06-2.94s8.26-3.6,14.72-3.6,14.74,3.54,14.74,3.54S176.36,189.64,176.36,190.43Z"
            fill="#98baf5"
          />
          <ellipse
            cx="161.58"
            cy="187.69"
            rx="14.78"
            ry="6.54"
            fill="#b0dff6"
          />
          <path
            d="M161.11,186.06c1.21,1.11,12.11-2.61,12.11-2.61s-4.08-1.53-4.81-1.71a43,43,0,0,0-8.52,2.62Z"
            fill="#90a3f4"
          />
          <path
            d="M161.78,186.75h-2.4V22.64L161.57,0l2.21,22.64v162.1A2,2,0,0,1,161.78,186.75Z"
            fill="#b0dff6"
          />
          <path
            d="M161.57,0l-1,10.42,1.21,12.4V186.75h0a2,2,0,0,0,2-2V22.64Z"
            fill="#98baf5"
          />
          <path
            d="M192.49,59.16s7.51,42.67-5,72.49c-6.93,16.5-18,36.25-18,36.25l-24.15-26.52L132.17,167.9s-11.35-31.88-3.39-52.27c6.24-16,4.39-61.09,4.39-61.09Z"
            fill="#c88821"
          />
          <rect
            x="129.56"
            y="52.67"
            width="69.63"
            height="3.77"
            rx="1.66"
            transform="translate(322.32 125.59) rotate(-174.15)"
            fill="#b0dff6"
          />
          <path
            d="M192.09,59.1s7.1,42.12-5.44,71.94c-6.93,16.5-18.19,35.84-18.19,35.84L143.2,140.06l-11,27.84s-11.71-33.15-3.76-53.54c6.24-16,4.4-61.1,4.4-61.1Z"
            fill="#e8a32c"
          />
          <path
            d="M188.71,55.15a2.55,2.55,0,0,0,0,3.84c-7.24-.71-17.8-1.78-17.8-1.78s-2-2.17.34-3.81C177,53.78,188.71,55.15,188.71,55.15Z"
            fill="#e8a32c"
          />
          <path
            d="M154.06,51.5a2.56,2.56,0,0,0,0,3.85c-7.24-.71-17.8-1.78-17.8-1.78s-2-2.17.34-3.81C142.39,50.14,154.06,51.5,154.06,51.5Z"
            fill="#e8a32c"
          />
          <path
            d="M159.38,22.64V33.77a4.41,4.41,0,0,0,2.74.59c.43,0,1.24-.23,1.66-.27V22.64L161.57,0Z"
            fill="#d2ddef"
          />
          <path
            d="M129.72,51.23l0-.44a1.67,1.67,0,0,1,1.83-1.49h.14a1.89,1.89,0,0,0,0,.23l0,.44a1.66,1.66,0,0,0,1.48,1.83l65.82,6.74a1.66,1.66,0,0,1-1.78,1.26l-66-6.76A1.65,1.65,0,0,1,129.72,51.23Z"
            fill="#b0dff6"
            opacity="0.5"
            style={{ mixBlendMode: 'multiply' }}
          />
          <path
            d="M161.57,0l-.47,4.87,1.59,16.24L162.9,33A14.66,14.66,0,0,1,161,33a8.63,8.63,0,0,1-1.66-.3v1.05a4.41,4.41,0,0,0,2.74.59c.43,0,1.24-.23,1.66-.27V22.64Z"
            fill="#bfd0ee"
          />
          <path
            d="M164,33.42c0,.56-1.07,1-2.4,1s-2.4-.45-2.4-1"
            fill="none"
            stroke="#d2ddef"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M132.81,53.26s.74,18.22-.32,35.6c16.13,5.53,43.93,11.5,61,12a185.24,185.24,0,0,0-1.4-41.78Z"
            fill="#c22218"
            opacity="0.13"
          />
          <ellipse
            cx="157.94"
            cy="101.19"
            rx="7.78"
            ry="7.34"
            transform="translate(41.16 247.97) rotate(-84.14)"
            fill="#c3397f"
          />
          <ellipse
            cx="158.2"
            cy="101.06"
            rx="27.67"
            ry="9.34"
            transform="translate(-27.38 129.3) rotate(-41.22)"
            fill="none"
            stroke="#fff"
            strokeMiterlimit="10"
            strokeWidth="2"
          />
          <ellipse
            cx="158.2"
            cy="101.06"
            rx="9.34"
            ry="27.67"
            transform="translate(-28.94 115.76) rotate(-37.06)"
            fill="none"
            stroke="#fff"
            strokeMiterlimit="10"
            strokeWidth="2"
          />
          <ellipse
            cx="146.89"
            cy="80.09"
            rx="3.68"
            ry="3.48"
            transform="translate(52.23 218.05) rotate(-84.14)"
            fill="#b4ecfd"
          />
          <ellipse
            cx="165.29"
            cy="122.31"
            rx="5.84"
            ry="5.51"
            transform="translate(26.75 274.25) rotate(-84.14)"
            fill="#f4da34"
          />
        </g>
        <g>
          <path
            d="M344.8,230.65a.88.88,0,0,0-.52-.35,9.16,9.16,0,0,0-2.42-.3.55.55,0,0,0-.43.17,1,1,0,0,0-.2.32l-.12.52-.83-.06-.84,0a17.19,17.19,0,0,0-3.13.29,10.48,10.48,0,0,0-2.77.91,5.68,5.68,0,0,0-2,1.57,3.52,3.52,0,0,0-.76,2.27,3.13,3.13,0,0,0,.68,2.09,5,5,0,0,0,1.67,1.3,9.92,9.92,0,0,0,2.19.76c.79.17,1.52.31,2.19.43s1.22.23,1.67.34.68.27.68.47a.77.77,0,0,1-.33.63,2.59,2.59,0,0,1-.85.42,7.18,7.18,0,0,1-1.19.23,12.22,12.22,0,0,1-1.35.08,9.54,9.54,0,0,1-1.19-.06l-.77-.09-.4-.09a1.6,1.6,0,0,0-.32,0,.53.53,0,0,0-.39.14.79.79,0,0,0-.17.38c-.05.27-.09.55-.12.86a8.77,8.77,0,0,0,0,.88v.41a2.42,2.42,0,0,0,0,.45.72.72,0,0,0,.23.36.92.92,0,0,0,.52.22,18.71,18.71,0,0,0,2.79.23,13.29,13.29,0,0,0,3.11-.34,8.32,8.32,0,0,0,2.48-1,5.22,5.22,0,0,0,1.65-1.62,4.05,4.05,0,0,0,.61-2.19,3.51,3.51,0,0,0-.64-2.18,4.64,4.64,0,0,0-1.6-1.31,8.68,8.68,0,0,0-2.08-.73c-.76-.17-1.45-.31-2.09-.42a13.42,13.42,0,0,1-1.59-.38c-.43-.13-.64-.35-.64-.63a.69.69,0,0,1,.27-.52,2.17,2.17,0,0,1,.73-.39,6.81,6.81,0,0,1,1.1-.23,9.54,9.54,0,0,1,1.37-.09l.85,0,.89.09,0,.52c0,.17,0,.34,0,.51a.83.83,0,0,0,.14.47.51.51,0,0,0,.39.28,7.59,7.59,0,0,0,1,.18c.32,0,.72,0,1.22,0a.85.85,0,0,0,.62-.2.91.91,0,0,0,.24-.49c.07-.36.13-.71.19-1.05s.11-.7.16-1.07.09-.76.12-1.18.06-.89.09-1.41A.72.72,0,0,0,344.8,230.65Z"
            fill="#fff"
          />
          <path
            d="M356.94,244.25c0-.11-.07-.23-.11-.36s-.17-.36-.26-.54-.18-.33-.28-.49-.35-.41-.56-.41a.83.83,0,0,0-.31.08l-.43.18a4.31,4.31,0,0,1-.51.22c-.2.08-.42.16-.65.23a6.25,6.25,0,0,1-.72.17,4.13,4.13,0,0,1-.66.07,2.92,2.92,0,0,1-1.13-.21l-.26-.12a2.56,2.56,0,0,1-.59-.43,2.28,2.28,0,0,1-.53-.8,2.45,2.45,0,0,1-.19-1,2,2,0,0,1,.25-1,2.46,2.46,0,0,1,.66-.78,3.38,3.38,0,0,1,1-.55,4.35,4.35,0,0,1,1.2-.26c0,.13,0,.26,0,.4a2.35,2.35,0,0,0,0,.26,6.07,6.07,0,0,0,.07.63,1.17,1.17,0,0,0,1.05,1,7.58,7.58,0,0,0,1.26.09,1.06,1.06,0,0,0,.66-.16,1.34,1.34,0,0,0,.27-.62,8.2,8.2,0,0,0,.14-1.5c0-.2,0-.41,0-.62s0-.42-.07-.65a1.47,1.47,0,0,0-.3-.86,2,2,0,0,0-.77-.45,4.26,4.26,0,0,0-1-.25,1.13,1.13,0,0,0-.18,0,8.69,8.69,0,0,0-3.77.35,7.93,7.93,0,0,0-2.28,1.17,6,6,0,0,0-1.6,1.79,4.29,4.29,0,0,0-.61,2.24,7,7,0,0,0,.08.92,4.76,4.76,0,0,0,.33,1.13,5.5,5.5,0,0,0,.68,1.18,4.35,4.35,0,0,0,1.18,1.06,6.74,6.74,0,0,0,1.79.75h0a10.08,10.08,0,0,0,2.5.28,7.26,7.26,0,0,0,1.22-.1,8,8,0,0,0,1.2-.27,7.44,7.44,0,0,0,1.07-.39,4.15,4.15,0,0,0,.84-.51.87.87,0,0,0,.37-.62A.77.77,0,0,0,356.94,244.25Z"
            fill="#fff"
          />
          <path
            d="M362.59,235.92c0-.1-.2-.16-.43-.18l-.37,0h-.4l-1,0a5.77,5.77,0,0,0-.9.12.64.64,0,0,0-.58.4,3.48,3.48,0,0,0-.14.83c-.06.84-.11,1.67-.14,2.47s0,1.61,0,2.43c0,.5,0,1,0,1.51s0,1,.07,1.54a1.52,1.52,0,0,0,.25.81,1.24,1.24,0,0,0,.91.33,10.86,10.86,0,0,0,1.28.07,2.39,2.39,0,0,0,.68-.07.74.74,0,0,0,.36-.2.66.66,0,0,0,.16-.37,3.69,3.69,0,0,0,.06-.55c.11-1.43.18-2.82.22-4.16s.06-2.77.06-4.31A1.94,1.94,0,0,0,362.59,235.92Zm.37-4.22a1.32,1.32,0,0,0-.42-.68,1.63,1.63,0,0,0-.74-.33,5.78,5.78,0,0,0-1.11-.09,2.51,2.51,0,0,0-1.78.51,2,2,0,0,0-.52,1.53,4.15,4.15,0,0,0,.11,1,1.39,1.39,0,0,0,.39.64,1.48,1.48,0,0,0,.71.35,5.56,5.56,0,0,0,1.09.09,4.12,4.12,0,0,0,1.2-.14,1.55,1.55,0,0,0,.73-.4,1.42,1.42,0,0,0,.37-.61,2.64,2.64,0,0,0,.1-.76A4,4,0,0,0,363,231.7Z"
            fill="#fff"
          />
          <path
            d="M375.77,238.92a5.32,5.32,0,0,0-1-1.61A5.45,5.45,0,0,0,373,236a6.15,6.15,0,0,0-2.71-.54,6.58,6.58,0,0,0-2.29.41,6.13,6.13,0,0,0-2,1.15,5.84,5.84,0,0,0-1.34,1.77,5.19,5.19,0,0,0-.5,2.26,5,5,0,0,0,.49,2.22,5.49,5.49,0,0,0,3.16,2.79,6.29,6.29,0,0,0,2.2.39,10.08,10.08,0,0,0,2.85-.38,5.12,5.12,0,0,0,2-1,1,1,0,0,0,.37-.73v-.2a.74.74,0,0,0-.05-.23c0-.16-.06-.31-.1-.47A3.68,3.68,0,0,0,375,243a1.91,1.91,0,0,0-.19-.36.34.34,0,0,0-.28-.12,1.77,1.77,0,0,0-.49.15,7.22,7.22,0,0,1-1.49.47,8.1,8.1,0,0,1-1.42.16,4.27,4.27,0,0,1-1.55-.29,3.44,3.44,0,0,1-1.2-.79c.62,0,1.27-.07,1.95-.14s1.33-.14,1.95-.22,1.23-.19,1.79-.3a14.27,14.27,0,0,0,1.42-.37.86.86,0,0,0,.46-.34,1,1,0,0,0,.12-.48A4.63,4.63,0,0,0,375.77,238.92Zm-5.63,1c-.77.06-1.51.1-2.21.13a2.29,2.29,0,0,1,1-1.14,2.72,2.72,0,0,1,1.51-.45,2.4,2.4,0,0,1,1.08.27,1.6,1.6,0,0,1,.8.89A16,16,0,0,1,370.14,239.89Z"
            fill="#fff"
          />
          <path
            d="M388.36,236.85a2.61,2.61,0,0,0-.94-.93,3.59,3.59,0,0,0-1.18-.4,6.59,6.59,0,0,0-1.1-.1,6.94,6.94,0,0,0-2,.28,6.32,6.32,0,0,0-1.83.84c0-.12,0-.22,0-.31a2.62,2.62,0,0,0,0-.27.63.63,0,0,0-.11-.41.57.57,0,0,0-.47-.15l-.67,0-.79.05-.77.08a4.59,4.59,0,0,0-.65.11c-.31.07-.5.21-.55.44a4.18,4.18,0,0,0-.11.82c0,.26,0,.52,0,.78v.77c0,1.12,0,2.24.12,3.37s.18,2.23.3,3.32a1.48,1.48,0,0,0,.29.77,1.32,1.32,0,0,0,.94.31l.35,0H380l.36,0a2,2,0,0,0,1-.24.68.68,0,0,0,.24-.56,1.7,1.7,0,0,0,0-.22,2.23,2.23,0,0,0,0-.23c-.09-.91-.16-1.81-.22-2.71s-.08-1.82-.08-2.75a5.75,5.75,0,0,1,1.33-.64,4.32,4.32,0,0,1,1.23-.2.76.76,0,0,1,.67.31,1.46,1.46,0,0,1,.22.83c0,.89,0,1.63,0,2.23s-.05,1.11-.09,1.51-.07.72-.09,1a4.59,4.59,0,0,0,0,.59.85.85,0,0,0,.75.94,8.75,8.75,0,0,0,1.08.16c.38,0,.69.06.92.06A.85.85,0,0,0,388,246a1.81,1.81,0,0,0,.22-.68q.14-.94.24-1.92c.07-.64.13-1.26.17-1.85s.07-1.16.09-1.67,0-1,0-1.36A3,3,0,0,0,388.36,236.85Z"
            fill="#fff"
          />
          <path
            d="M401.08,244.25c0-.11-.07-.23-.11-.36s-.17-.36-.26-.54-.19-.33-.28-.49a.71.71,0,0,0-.56-.41.83.83,0,0,0-.31.08l-.43.18a4.31,4.31,0,0,1-.51.22c-.21.08-.42.16-.66.23a5.65,5.65,0,0,1-.71.17,4.13,4.13,0,0,1-.66.07,2.88,2.88,0,0,1-1.13-.21,2.5,2.5,0,0,1-.85-.55,2.28,2.28,0,0,1-.53-.8,2.45,2.45,0,0,1-.19-1,2.07,2.07,0,0,1,.24-1,2.62,2.62,0,0,1,.67-.78,3.38,3.38,0,0,1,1-.55,4.35,4.35,0,0,1,1.2-.26c0,.22,0,.43,0,.66a6.07,6.07,0,0,0,.07.63,1.17,1.17,0,0,0,1.05,1,7.54,7.54,0,0,0,1.25.09,1.07,1.07,0,0,0,.67-.16,1.25,1.25,0,0,0,.26-.62,7.41,7.41,0,0,0,.14-1.5c0-.2,0-.41,0-.62s0-.42-.07-.65a1.62,1.62,0,0,0-.3-.86,2,2,0,0,0-.77-.45,4.77,4.77,0,0,0-1.19-.28,8.69,8.69,0,0,0-3.77.35,7.93,7.93,0,0,0-2.28,1.17,6.22,6.22,0,0,0-1.61,1.79,4.37,4.37,0,0,0-.6,2.24,7,7,0,0,0,.08.92,4.76,4.76,0,0,0,.33,1.13,5.5,5.5,0,0,0,.68,1.18,4.35,4.35,0,0,0,1.18,1.06,6.74,6.74,0,0,0,1.79.75,9.84,9.84,0,0,0,2.53.29,7.26,7.26,0,0,0,1.22-.1,8,8,0,0,0,1.2-.27,7.44,7.44,0,0,0,1.07-.39,4.8,4.8,0,0,0,.84-.51.87.87,0,0,0,.37-.62A.77.77,0,0,0,401.08,244.25Z"
            fill="#fff"
          />
          <path
            d="M413.6,238.92a5.32,5.32,0,0,0-1-1.61,5.45,5.45,0,0,0-1.77-1.31,6.12,6.12,0,0,0-2.71-.54,6.62,6.62,0,0,0-2.29.41,6.13,6.13,0,0,0-1.95,1.15,6,6,0,0,0-1.34,1.77,5.19,5.19,0,0,0-.49,2.26,5,5,0,0,0,.48,2.22,5.57,5.57,0,0,0,3.16,2.79,6.29,6.29,0,0,0,2.2.39,10.08,10.08,0,0,0,2.85-.38,5,5,0,0,0,2-1,.92.92,0,0,0,.37-.73v-.2a.74.74,0,0,0-.05-.23c0-.16-.06-.31-.1-.47a3.68,3.68,0,0,0-.15-.47,1.91,1.91,0,0,0-.19-.36.32.32,0,0,0-.28-.12,1.77,1.77,0,0,0-.49.15,7.22,7.22,0,0,1-1.49.47,8,8,0,0,1-1.42.16,4.27,4.27,0,0,1-1.55-.29,3.39,3.39,0,0,1-1.19-.79c.62,0,1.26-.07,1.94-.14s1.33-.14,2-.22,1.23-.19,1.79-.3a14.27,14.27,0,0,0,1.42-.37.86.86,0,0,0,.46-.34,1,1,0,0,0,.12-.48A4.63,4.63,0,0,0,413.6,238.92Zm-5.63,1c-.77.06-1.51.1-2.21.13a2.29,2.29,0,0,1,1-1.14,2.72,2.72,0,0,1,1.51-.45,2.4,2.4,0,0,1,1.08.27,1.65,1.65,0,0,1,.81.89A16.39,16.39,0,0,1,408,239.89Z"
            fill="#fff"
          />
        </g>
      </g>
      {resources && (
        <g className="resources-wrap" transform="translate(240, 50)">
          <ResourceLink
            r={resources[0]}
            svgComponent={resource1SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[0], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[1]}
            svgComponent={resource2SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[1], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[2]}
            svgComponent={resource3SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[2], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[3]}
            svgComponent={resource4SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[3], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[4]}
            svgComponent={resource5SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[4], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[5]}
            svgComponent={resource6SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[5], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
        </g>
      )}
    </g>
  );
};
export default ScienceLink;
